import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Loader2, CreditCard } from "lucide-react";
import api from "@/lib/api";
import { Empty, TabHeading, fmtDate } from "./shared";

export default function MembershipTab({ athlete, refreshKey }) {
  const [membership, setMembership] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/memberships");
      const m = data.find((x) => x.id === athlete.membership_id)
        || data.find((x) => x.email && athlete.email && x.email === athlete.email)
        || data.find((x) => x.member_name === athlete.name);
      setMembership(m || null);
    } catch { toast.error("Failed to load membership."); } finally { setLoading(false); }
  }, [athlete]);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (loading) return <div className="flex justify-center py-16 text-white/40"><Loader2 className="animate-spin" /></div>;

  const rows = membership && [
    ["Plan", membership.plan_name || "—"],
    ["Type", membership.membership_type],
    ["Price", `$${membership.price}/${membership.interval}`],
    ["Status", membership.status],
    ["Founding Athlete", membership.founding_athlete ? "Yes" : "No"],
    ["Start Date", fmtDate(membership.start_date)],
  ];

  return (
    <div data-testid="af-membership">
      <TabHeading>Membership</TabHeading>
      {!membership ? (
        <Empty testid="af-membership-empty">No membership linked. Manage memberships from the Memberships tab.</Empty>
      ) : (
        <div className="bg-[#121212] border border-white/10 p-6 max-w-md" data-testid="af-membership-card">
          <div className="flex items-center gap-2 mb-5">
            <CreditCard size={18} className="text-white/50" />
            <p className="font-display font-bold uppercase tracking-tight text-lg">{membership.member_name}</p>
          </div>
          <dl className="space-y-3">
            {rows.map(([k, v]) => (
              <div key={k} className="flex justify-between border-b border-white/5 pb-2">
                <dt className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40">{k}</dt>
                <dd className="text-white/80 text-sm capitalize">{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </div>
  );
}
